import React from 'react';
import { useSelector } from "react-redux";
import TargetHandle from './TargetHandle';
import SourceHandle from './SourceHandle';
import { Chip, Tooltip } from '@mui/material';
import Iconify from '../../../common/iconify/Iconify';
import { OPTIONS_TO_DISPLAY, EXCLUDE_FOR_SIDEBAR_IPTS } from '../../constant';
import { getNodeType } from '../registry';

/** Compact badges for configured properties (same as in CommonNode) */
function NodeBadges({ data, keysToExclude }) {
    const hasFM = data?.filterKey || data?.mandatory
    const hasInput = !keysToExclude.includes('inputMode') && data?.inputMode
    const hasRegex = !keysToExclude.includes('inputRegex') && data?.inputRegex
    const hasMin  = !keysToExclude.includes('minSize') && data?.minSize > 0
    const hasMax  = !keysToExclude.includes('maxSize') && data?.maxSize > 0
    if (!hasFM && !hasInput && !hasRegex && !hasMin && !hasMax) return null

    return (
        <div className="node-badges">
            {data?.mandatory && <span className="node-badge node-badge-required">Required</span>}
            {hasInput && <span className="node-badge">Input: {data.inputMode}</span>}
            {hasRegex && <span className="node-badge">Regex</span>}
            {hasMin && <span className="node-badge">Min: {data.minSize}</span>}
            {hasMax && <span className="node-badge">Max: {data.maxSize}</span>}
            {data?.filterKey && <span className="node-badge node-badge-filter">Filter: {data.filterKey}</span>}
        </div>
    )
}

function OptionsNode({ data, icon }) {
  const lang = useSelector(state => state.lang.ui.lang);
  const config = getNodeType(data?.type)
  const color = config?.color || '#666'
  const label = config?.label || data?.type
  const questionText = data?.question?.[lang]
  const keysToExclude = EXCLUDE_FOR_SIDEBAR_IPTS?.[data?.type] || []

  const showMoreChip = data?.answerOptionList?.length > OPTIONS_TO_DISPLAY
  const moreCount = data?.answerOptionList?.length - OPTIONS_TO_DISPLAY
  const first3Options = data?.answerOptionList?.slice(0, OPTIONS_TO_DISPLAY)

  const questionTooltip = data?.question
      ? Object.entries(data.question).map(([k, v]) => `${k}: ${v}`).join(' · ')
      : ''

  return (
    <div className={`callflow-node ${data?.status == 'D' && 'disabled-node'}`} style={{ flexDirection: 'column' }}>
      {/* Colored header: small icon + question text */}
      <div className="node-type-header" style={{ backgroundColor: color }}>
        <Iconify icon={icon} sx={{ width: 14, height: 14, color: 'rgba(255,255,255,0.9)', flexShrink: 0 }} />
        <Tooltip title={<span style={{ fontSize: 12 }}>{questionTooltip}</span>} placement="bottom">
            <span className="node-type-question">{questionText || label}</span>
        </Tooltip>
      </div>

      {/* Body: options list + badges */}
      <div className="callflow-body">
        <TargetHandle id={data?.id} />

        {data?.answerOptionList && data.answerOptionList.length > 0 && (
          <div className="options-list">
            {first3Options?.map((op) => (
              <div className='option' key={op?.key}>
                <Tooltip title={<div>{Object.entries(op?.value || {}).map(([k, v]) => (<div key={k}>{k}: {v}</div>))}{op?.label && <div>Label: {op.label}</div>}{op?.price && <div>Price: ${op.price}</div>}{op?.inputType && <div>Input: {op.inputType}</div>}</div>}>
                  <span className='text'>{op?.value?.[lang] || op?.key}{op?.price ? ` ($${op.price})` : ''}</span>
                </Tooltip>
                <SourceHandle key={op?.key} id={op?.key} styles={{ visibility: data?.optionsNode ? 'visible' : 'hidden' }} />
              </div>
            ))}
            {showMoreChip && <Chip label={`+ ${moreCount}`} size="small" sx={{ mt: 0.5 }} />}
          </div>
        )}

        <NodeBadges data={data} keysToExclude={keysToExclude} />
        <SourceHandle id={data?.id} styles={{ visibility: data?.optionsNode ? 'hidden' : 'visible' }} />
      </div>
    </div>
  );
}

export default OptionsNode
